<template>
  <div class="asd-controls">
    <slot></slot>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'FormControls',
    props: {
        enabledWhen: {
            required: false,
            type: Boolean,
            default: _ => true,
        },
    },
    watch: {
        enabledWhen(newVal, oldVal) {
            this.$nextTick(() => {
                _.each(this.$slots.default, node => {
                    if (node.tag === 'button') {
                        node.elm.disabled = !newVal
                    }
                })
            })
        },
    },
    mounted() {
        _.each(this.$slots.default, node => {
            if (node.tag === 'button') {
                node.elm.disabled = !this.enabledWhen
            }
        })
    },
}
</script>
